import { useMutation } from "@tanstack/react-query";
import {
	type PortfolioAlertBoxCalculatorAccessRequestDTO,
	type PortfolioAlertBoxCalculatorAccessResponseDTO,
	postPortfolioIdAlertBoxesCalculatorAccessV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type CalculatorAccessVariables = PortfolioAlertBoxCalculatorAccessRequestDTO & {
	contractId: number;
};

export const useAlertBoxCalculatorAccessMutation = () =>
	useMutation<
		PortfolioAlertBoxCalculatorAccessResponseDTO,
		Error,
		CalculatorAccessVariables
	>({
		mutationFn: processResponse(
			({ contractId, ...body }: CalculatorAccessVariables) =>
				postPortfolioIdAlertBoxesCalculatorAccessV2(body, contractId),
		),
	});
